import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'spassu-code',
});

export const activityDetailRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-detail',
  parent: rootRouteRef,
  path: '/:activityId',
});

export const activityConnectRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-connect',
  parent: rootRouteRef,
  path: '/connect/:activityId',
});

export const activityMetricsRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-metrics',
  parent: rootRouteRef,
  path: '/metrics/:activityId',
});

export const activityCliRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-cli',
  parent: rootRouteRef,
  path: '/cli/:activityId',
});

export const activityNewRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-new',
  parent: rootRouteRef,
  path: '/new',
});

export const controlPlaneActivityNewRouteRef = createSubRouteRef({
  id: 'spassu-code/control-plane-activity-new',
  parent: rootRouteRef,
  path: '/new/control-plane',
});

export const controlPlaneNewRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-new',
  optional: true,
});

export const controlPlaneConnectRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-connect',
  params: ['activityId'],
  optional: true,
});

export const controlPlaneCockpitRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-cockpit',
  params: ['activityId'],
  optional: true,
});
